import React, { Component } from 'react';
import axios from "axios";
import {NotificationContainer, NotificationManager} from 'react-notifications';

import { Link } from 'react-router-dom';
import AccountMenu from './AccountMenu';

class Account extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userDetails:'',
            full_name:'',
            email_id:'',
            mobile_number:'',
            mobile_otp:'',
            enable_otp_box:false,
            otp_resend_count:2,
            editName:false,
            editEmail:false,
            editMobile:false,
            serviceCheck:false,
        }   
    }

    componentDidMount() {
        this.preloadProfile();
    }

    async preloadProfile() {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
          const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/profile',params);
           let resVal=response.data;
            if(resVal.status==='success'){
                this.setState({userDetails:resVal.data,full_name:resVal.data.username,email_id:resVal.data.email_id,mobile_number:resVal.data.mobile_number});
                this.setState({serviceCheck:true});
            }else{
                NotificationManager.error(resVal.message);
                this.setState({serviceCheck:true});
            }
        } catch (error) {
          console.error(error);
          this.setState({serviceCheck:true});
        }
    }


    

    async submitName(){

        const { full_name}  = this.state ;

        if(full_name.length < 3) {
            NotificationManager.error('Please enter the valid name');
        }else{

          const params = new URLSearchParams();
          params.append('full_name', full_name);
          params.append('profileType', 'name');
          params.append('token', localStorage.getItem('byos_token'));
            try {
                const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/profileEdit',params);
                let resVal=response.data;
                if(resVal.status=='success'){
                    this.setState({editName:false});
                    NotificationManager.success(resVal.message);
                    this.preloadProfile();
                }else{
                    NotificationManager.error(resVal.message);
                }
            } catch (error) {
                console.error(error);
            }

        }
    }


    async submitEmail(){

        const { email_id}  = this.state ;

        let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (reg.test(email_id) === false) {
          NotificationManager.error('Please enter the valid email id');
        }else{

          const params = new URLSearchParams();
          params.append('email_id', email_id);
          params.append('profileType', 'email');
          params.append('token', localStorage.getItem('byos_token'));
            try {
                const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/profileEdit',params);
                let resVal=response.data;
                if(resVal.status=='success'){
                    this.setState({editEmail:false});
                    NotificationManager.success(resVal.message);
                    this.preloadProfile();
                }else{
                    NotificationManager.error(resVal.message);
                }
            } catch (error) {
                console.error(error);
            }

        }
    }
    

    async getOTP(){

        const { mobile_number, enable_otp_box, userDetails }  = this.state ;

        if(mobile_number==userDetails.mobile_number){
            NotificationManager.error('Please try different number');
        }else if(mobile_number.length==10){
           
            try {
                const params = new URLSearchParams();
                params.append('mobile_number', mobile_number);
                params.append('token', localStorage.getItem('byos_token'));
                const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/editMobileOTP', params);
                let resVal=response.data;
                if(resVal.status==='success'){
                    NotificationManager.success(resVal.message);
                    this.setState({enable_otp_box:true});
                }else{
                    NotificationManager.error(resVal.message);
                    this.setState({enable_otp_box:false});
                }
            } catch (error) {
                console.error(error);
            }

        }else{
            NotificationManager.error('Invalid mobile number');
        }
    }


    async resendOTP(){
        if(this.state.otp_resend_count>0){
            this.setState({otp_resend_count:this.state.otp_resend_count-1});
            this.setState({enable_otp_box:false});
            this.getOTP();
        }else{
            NotificationManager.success('Maximum attempt limit reached, Please try later');
        }
    }


    async submitMobile(){

            const { mobile_number, mobile_otp, enable_otp_box, userDetails }  = this.state ;
    
            if(mobile_number==userDetails.mobile_number){
                NotificationManager.error('Please try different number');
            }else if(mobile_number.length==10){
    
              const params = new URLSearchParams();
              params.append('mobile_number', mobile_number);
              params.append('mobile_otp', mobile_otp);
              params.append('profileType', 'mobile');
              params.append('token', localStorage.getItem('byos_token'));
                try {
                    const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/profileEdit',params);
                    let resVal=response.data;
                    if(resVal.status=='success'){
                        this.setState({editMobile:false,enable_otp_box:false});
                        NotificationManager.success(resVal.message);
                        this.preloadProfile();
                    }else{
                        NotificationManager.error(resVal.message);
                    }
                } catch (error) {
                    console.error(error);
                }
    
            }else{
                NotificationManager.error('Invalid mobile number');
            }
    }


    loadNameComponent(){
        const { editName, userDetails, full_name }  = this.state ;
        if(editName==true){
            return(
                <div class="form-row">
                    <div class="ps-form__group col-md-6">
                        <label class="ps-form__label">Full Name <span className="editButton hand" title="Edit"><i className="fa fa-pencil"></i></span></label>
                        <input type="text" class="form-control ps-form__input" name="full_name" onChange={(event)=>this.setState({'full_name':event.target.value})} value={full_name}/>
                        
                        <br/>

                        <button type="button" class="ps-btn ps-btn--sm ps-btn--warning byosButton" onClick={()=>this.submitName()}>Save</button>
                        <button type="button" class="ps-btn ps-btn--sm ps-btn--primary byosButton" onClick={()=>this.setState({editName:false})}>Cancel</button>
                    </div>
                </div>
            )
        }else{
            return(
            <div class="form-row">
                <div class="ps-form__group col-md-6">
                <label class="ps-form__label">Full Name <span className="editButton hand" title="Edit" onClick={()=>this.setState({editName:true})}><i className="fa fa-pencil"></i></span></label>
                <input type="text" class="form-control ps-form__input" value={userDetails.username} disabled/>
                </div>
            </div>
            )
        }
    }



    loadEmailComponent(){
        const { editEmail, userDetails, email_id }  = this.state ;
        if(editEmail==true){
            return(
                <div class="form-row">
                    <div class="ps-form__group col-md-6">
                        <label class="ps-form__label">Email Address <span className="editButton hand" title="Edit"><i className="fa fa-pencil"></i></span></label>
                        <input type="text" class="form-control ps-form__input" name="email_id" onChange={(event)=>this.setState({'email_id':event.target.value})} value={email_id}/>
                        
                        <br/>

                        <button type="button" class="ps-btn ps-btn--sm ps-btn--warning byosButton" onClick={()=>this.submitEmail()}>Save</button>
                        <button type="button" class="ps-btn ps-btn--sm ps-btn--primary byosButton" onClick={()=>this.setState({editEmail:false})}>Cancel</button>
                    </div>
                </div>
            )
        }else{
            return(
            <div class="form-row">
                <div class="ps-form__group col-md-6">
                <label class="ps-form__label">Email Address <span className="editButton hand" title="Edit" onClick={()=>this.setState({editEmail:true})}><i className="fa fa-pencil"></i></span></label>
                <input type="text" class="form-control ps-form__input" value={userDetails.email_id} disabled/>
                </div>
            </div>
            )
        }
    }


    
    loadMobileComponent(){
        const { enable_otp_box, editMobile, userDetails, mobile_number, mobile_otp }  = this.state ;
        if(editMobile==true){
            return(
                <>
                <div class="form-row">
                <div class="ps-form__group col-md-6">
                    <label class="ps-form__label">Mobile Number *</label>
                    <div class="mobileNumberBox">
                        <input class="form-control ps-form__input mobileNumberBoxLeft" maxLength='10' type="text" value={mobile_number} onChange={(event)=>this.setState({mobile_number:event.target.value})}/>
                        <input class="btn mobileNumberBoxRight" name="mobile_otp_button" value="Obtain OTP" type="button" onClick={()=>this.getOTP()}/>
                    </div>
                </div>
                </div>

                {(enable_otp_box==true)?
                <div class="form-row">
                    <div class="ps-form__group col-md-6">
                    <label class="ps-form__label">OTP *</label>
                    <div class="mobileNumberBox">
                        <input class="form-control ps-form__input mobileNumberBoxLeft" name="mobile_otp" maxLength='5' type="text" value={mobile_otp}  onChange={(event)=>this.setState({mobile_otp:event.target.value})}/>
                        <button class="btn mobileNumberBoxRight" name="mobile_otp_resend_button" onClick={()=>this.resendOTP()}>Resend OTP ({this.state.otp_resend_count})</button>
                    </div>
                </div>
                </div>
                : null }

                <div class="form-row">
                    <div class="ps-form__group col-md-6">
                        <br/>
                        <button type="button" class="ps-btn ps-btn--sm ps-btn--warning byosButton" onClick={()=>this.submitMobile()}>Save</button>
                        <button type="button" class="ps-btn ps-btn--sm ps-btn--primary byosButton" onClick={()=>this.setState({editMobile:false})}>Cancel</button>
                    </div>
                </div>
            </>
            )
        }else{
            return(
            <div class="form-row">
                <div class="ps-form__group col-md-6">
                <label class="ps-form__label">Mobile Number <span className="editButton hand" title="Edit" onClick={()=>this.setState({editMobile:true})}><i className="fa fa-pencil"></i></span></label>
                <input type="text" class="form-control ps-form__input" value={userDetails.mobile_number} disabled/>
                </div>
            </div>
            )
        }
    }


    render() {
        const { editName, userDetails }  = this.state ;
        const profileName = userDetails && userDetails.username ? userDetails.username : localStorage.getItem('BYOS_UserName');
        const profileEmail = userDetails && userDetails.email_id ? userDetails.email_id : '-';
        const profileMobile = userDetails && userDetails.mobile_number ? userDetails.mobile_number : '-';

        return (
            <div className="ps-account-page ps-account-page--profile">
                <div className="ps-categogy ps-categogy--separate ps-account-shell">
                    <div className="container whiteContainer ps-account-shell__container">
                        <div className="ps-account-shell__layout">
                            <AccountMenu {...this.props}/>

                            <main className="ps-account-shell__content">
                                <div className="ps-account-shell__topbar">
                                    <ul className="ps-breadcrumb ps-account-shell__breadcrumb">
                                        <li className="ps-breadcrumb__item"><Link to="/">Account settings</Link></li>
                                        <li className="ps-breadcrumb__item active" aria-current="page">Profile information</li>
                                    </ul>
                                    <div className="ps-account-shell__eyebrow">Personal dashboard</div>
                                </div>

                                <section className="ps-account-shell__hero">
                                    <div className="ps-account-shell__heroCopy">
                                        <span className="ps-account-shell__label">Your account</span>
                                        <h1>{profileName || 'Profile'}</h1>
                                        <p>Keep your profile details, contact information and mobile number up to date from one clean view.</p>
                                    </div>
                                </section>

                                <section className="ps-account-shell__panel">
                                    <div className="accountBox ps-form--review ps-account-shell__card">
                                        <div className="ps-account-shell__cardHeader">
                                            <span className="ps-account-shell__panelLabel">Profile details</span>
                                            <h2>Edit your account information</h2>
                                        </div>

                                        <div className="ps-account-dashboard__fieldGroup">
                                            {this.loadNameComponent()}
                                        </div>

                                        <div className="ps-account-dashboard__fieldGroup">
                                            {this.loadEmailComponent()}
                                        </div>

                                        <div className="ps-account-dashboard__fieldGroup">
                                            {this.loadMobileComponent()}
                                        </div>
                                    </div>
                                </section>
                            </main>
                        </div>
                    </div>
                </div>
                <NotificationContainer/>
            </div>
        );
    }
}

export default Account;
